import React, {useEffect, useState} from "react";
import "./style.css";
import leftArrow from "../../../assets/images/common/left-arrow.svg";
import axios from "axios";
import {GRAPHQL, PAYMENT_CANCEL, PAYMENT_REFUND} from "../../../constants/ApiUrl";
import {GET_PAYMENT} from "../../../constants/query/Payment.query";
import {DetailDto} from "../dto/Payment.dto";
import * as ImagePath from "../ImagePath";
import {useLocation, useNavigate} from "react-router-dom";
import {PAYMENT} from "../../../constants/Routes";
import {getPaymentTypeName, PaymentType} from "../constants/PaymentType";
import {getLicenseName, LicenseType} from "../../institution/detail/license/constants/LicenseType";
import Popup from "../../common/popup/Popup";
import {PopupProps} from "../../common/popup/Popup.props";
import Toast from "../../common/toast/Toast";

export default function Detail() {
    const location = useLocation();
    const navigate = useNavigate();

    const [payment, setPayment] = useState<DetailDto>(new DetailDto());
    const [popupProps, setPopupProps] = useState<PopupProps | null>(null);
    const [toastProps, setToastProps] = useState<string[]>([]);

    const columns = [["총결제금액", "결제일시", "공급가액", "부가세"], ["결제방법", "결제정보", "결제상태"]];

    useEffect(() => {
        getPayment();
    }, []);

    const getPayment = () => {
        axios.post(GRAPHQL, {query: GET_PAYMENT(location.state.seq)})
            .then(response => {
                setPayment(response.data.data.getPayment);
            });
    };

    const getLicenseThumbnail = () => {
        switch (payment.licenseType) {
            case LicenseType.CONTROL_SYSTEM:
                return ImagePath.Control;
            case LicenseType.IMS:
                return ImagePath.IMS;
            case LicenseType.PMS:
                return ImagePath.PMS;
            case LicenseType.WEATHER:
                return ImagePath.Weather;
            case LicenseType.PILOT:
                return ImagePath.Pilot;
        }
    };

    const onCancelClick = () => {
        setPopupProps({
            subject: "결제를 취소하시겠습니까?",
            message1: "결제를 취소하시겠습니까?",
            message2: "취소 시 결제 내역은 환불처리됩니다.",
            buttonName: "결제취소",
            onConfirm: () => {
                axios.put(PAYMENT_CANCEL(location.state.seq))
                    .then(() => {
                            setPopupProps(null);
                            setToastProps([...toastProps, "결제 취소되었습니다."]);
                            getPayment();
                        },
                        error => {
                            console.log(error)
                            setToastProps([...toastProps, "결제 취소를 실패하였습니다."]);
                        });
            },
            useCloseButton: true,
            onClose: () => setPopupProps(null)
        });
    };

    const onRefundClick = () => {
        setPopupProps({
            subject: "환불 처리하시겠습니까?",
            message1: "해당 요청을 환불 처리하시겠습니까?",
            message2: null,
            buttonName: "환불 처리",
            onConfirm: () => {
                axios.put(PAYMENT_REFUND(location.state.seq))
                    .then(() => {
                        setPopupProps(null);
                        setToastProps([...toastProps, "환불 처리가 완료되었습니다."]);
                        getPayment();
                    });
            },
            useCloseButton: true,
            onClose: () => setPopupProps(null)
        });
    };

    const handleToastClose = () => {
        setToastProps(toastProps.slice(1));
    }

    const requestToRefund = () => {
        if (payment.status !== PaymentType.REFUND_REQUEST) {
            return;
        }

        axios.put(PAYMENT_REFUND(location.state.seq)).then(
            response => {
                setPopupProps(null);
                setToastProps([...toastProps, "환불 처리가 완료되었습니다."]);
                getPayment();
            }, error => {
                console.log(error)
                setToastProps([...toastProps, "환불 처리를 실패하였습니다."]);
            }
        );
    }

    return (
        <>
            <div className="pay-refund-complete">
                <main className="wrapper">
                    <div className="pay-complete-body">
                        <div className="pay-detail-title">
                            <div className="left">
                                <button className="arrow" onClick={() => navigate(PAYMENT)}>
                                    <img src={leftArrow} alt="arrow"/>
                                </button>
                                <div className="text">
                                    결제 상세
                                </div>
                            </div>
                            <div className="right">
                                {
                                    (payment.status !== PaymentType.REFUNDED && payment.status !== PaymentType.CANCELED) && (
                                        <button className="delete-button" onClick={onCancelClick}>
                                            결제취소
                                        </button>
                                    )
                                }
                            </div>
                        </div>
                        <div className="pay-detail-license">
                            <div className="pay-license-box">
                                <div className="license-box-title">
                                    <div className="program" data-testid="title">
                                        {payment.lectureName !== "" ? "강의" : "프로그램"}
                                    </div>
                                    <div className="total-price">
                                        단가
                                    </div>
                                    <div className="total-price">
                                        수량
                                    </div>
                                    <div className="total-price">
                                        총금액
                                    </div>
                                </div>
                                <div className="license-box-contents">
                                    <div className="program">
                                        <div className="img-wrapper">
                                            <img
                                                src={payment.lectureName !== "" ? payment.thumbnailUrl : getLicenseThumbnail()}
                                                alt="icon"/>
                                        </div>
                                        <div className="text">
                                            {payment.lectureName !== "" ? payment.lectureName : getLicenseName(payment.licenseType)}
                                        </div>
                                    </div>
                                    <div className="total-count">
                                        {payment.price.toLocaleString()}
                                    </div>
                                    <div className="total-count">
                                        1
                                    </div>
                                    <div className="total-price">
                                        {payment.price}
                                    </div>
                                </div>
                            </div>
                            <div className="pay-detail-box">
                                <div className="title">
                                    결제내용
                                </div>
                                <div className="pay-detail">
                                    <div className="pay-detail-name">
                                        {
                                            columns[0].map((column, index) => {
                                                return (
                                                    <div className="text" key={index}>
                                                        {column}
                                                    </div>
                                                );
                                            })
                                        }
                                    </div>
                                    <div className="pay-detail-price">
                                        <div className="text-span">
                                            {(payment.price + payment.price * 0.1).toLocaleString()}원
                                        </div>
                                        <div className="text">
                                            {payment.paidAt}
                                        </div>
                                        <div className="text">
                                            {payment.price.toLocaleString()}원
                                        </div>
                                        <div className="text-line">
                                            {(payment.price * 0.1).toLocaleString()}원
                                        </div>
                                    </div>
                                </div>
                                <div className="payment-detail">
                                    <div className="payment-detail-name">
                                        {
                                            columns[1].map((column, index) => {
                                                return (
                                                    <div className="text" key={index}>
                                                        {column}
                                                    </div>
                                                );
                                            })
                                        }
                                    </div>
                                    <div className="payment-detail-price">
                                        <div className="text">
                                            카드결제
                                        </div>
                                        {
                                            <div className="text">
                                                {payment.bank} {payment.cardNumber !== "" ? payment.cardNumber : ""}
                                            </div>
                                        }
                                        <div className="text">
                                            {getPaymentTypeName(payment.status)}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {
                                (payment.status === PaymentType.CANCELED || payment.status === PaymentType.REFUND_REQUEST || payment.status === PaymentType.REFUNDED) && (
                                    <div
                                        className={`pay-refund-request-box complete`}>
                                        <div className="title">
                                            {payment.status === PaymentType.CANCELED ? "취소" : "환불"} 요청 내용
                                        </div>
                                        <div className="payment-refund">
                                            <div className="payment-detail-name">
                                                <div className="text">
                                                    제품명
                                                </div>
                                                <div className="text">
                                                    {payment.status === PaymentType.CANCELED ? "취소" : "환불"} 수량
                                                </div>
                                                <div className="text">
                                                    {payment.status === PaymentType.CANCELED ? "취소" : "환불"} 금액
                                                </div>
                                                <div className="text">
                                                    {payment.status === PaymentType.CANCELED ? "취소" : "환불"} 사유
                                                </div>
                                            </div>
                                            <div className="payment-refund-request-detail">
                                                <div className="text">
                                                    {payment.lectureName !== "" ? payment.lectureName : getLicenseName(payment.licenseType)}
                                                </div>
                                                <div className="text">
                                                    1
                                                </div>
                                                <div className="text">
                                                    {payment.refundPrice}
                                                </div>
                                                <div className="text">
                                                    {payment.reason}
                                                </div>
                                            </div>
                                        </div>
                                        <div onClick={() => requestToRefund()}
                                             className={`result-detail-button ${payment.status !== PaymentType.REFUND_REQUEST && "cancel-complete"}`}>
                                            {payment.status === PaymentType.REFUND_REQUEST ? "환불 처리" : "처리 완료"}
                                        </div>
                                    </div>
                                )
                            }
                        </div>
                    </div>
                </main>
            </div>
            {popupProps && <Popup data={popupProps}/>}
            {toastProps.map((toastProp, index) => {
                return (
                    <Toast message={toastProp} onClose={handleToastClose} key={index}/>
                );
            })}
        </>
    );
}